<template lang="pug">
  v-select.group-select(:value="selectedOption" :options="options" label="name" @input="onInput" :placeholder="placeholder")
</template>

<script>
import vSelect from 'vue-select'
import Security from '@/service/apis/Security'

export default {
  props: {
    value: {
      type: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select Group'
    }
  },
  data: () => ({
    loading: true,
    options: [],
    selectedOption: null
  }),
  created() {
    this.loading = true
    Security.listGroups({ size: 1000 }) // TODO: fix check for more groups
      .then((resp) => {
        this.options = resp.data.content
        this.updateSelectedOption()
      })
      .catch((e) => { this.$emit('error', e) })
      .then(() => { this.loading = false })
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find(o => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedGroup() {
      return this.selectedOption
    },
    setSelectedGroup(group) {
      const exisiting = this.options.find(o => o.id === group.id)
      if (!exisiting) {
        this.options.push(group)
      }
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/GroupSelect.vue